import { InputNumberLocalized } from '@components'

import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanySharedCapital = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      name="sharedCapital"
      label={t('settings.organization.organization_info.basic_info.shared_capital.label')}
      render={({ field }) => (
        <InputNumberLocalized
          {...field}
          alignment="left"
          min={0}
          placeholder="0.00"
          size="sm"
          suffix={<Icon icon="euro" />}
        />
      )}
    />
  )
}
